export const LOADING_INDICATOR_CATEGORY_KEY = 'base' as const;
export const LOADING_INDICATOR_COMPONENT_KEY = 'loadingIndicator' as const;
